import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// user endpoints
export const userApi = {
  addUser: (data) => api.post("/user", data),
  getUserByEmail: (data) => api.get("/user/byemail", { params: data }),
};

// login endpoints
export const loginApi = {
  loginUser: (data) => api.post("/login", data),
};

// candidate endpoints
export const candidateApi = {
  updateProfile: (userId, data) => api.patch(`/candidates/${userId}`, data),
  updateSkills: (userId, data) =>
    api.patch(`/candidates/${userId}/skills`, data),
  updateWorkHistory: (userId, data) =>
    api.patch(`/candidates/${userId}/work-history`, data),
  updateEducation: (userId, data) =>
    api.patch(`/candidates/${userId}/education`, data),
  updatePersonalInfo: (userId, data) =>
    api.patch(`/candidates/${userId}/personal-info`, data),
  updateBasicInfo: (userId, data) =>
    api.patch(`/candidates/${userId}/basic-info`, data),
  updatePortfolio: (userId, data) =>
    api.patch(`/candidates/${userId}/portfolio`, data),
  updateJobPreference: (userId, data) =>
    api.patch(`/candidates/${userId}/job-preference`, data),
  getProfileByUserId: (userId) => api.get(`/candidates/user/${userId}`),
  getDashboardMainRoleCounts: () =>
    api.get(`/candidates/dashboard-main-role-counts`),
  fetchInteractions: (candidateId) =>
    api.get(`/interactions/candidate/${candidateId}`),
  setConsent: (interactionId, consent) =>
    api.patch(`/interactions/${interactionId}/consent`, { consent }),
  acceptInvitation: (interactionId) =>
    api.patch(`/interactions/${interactionId}/consent`, { consent: true }),
  declineInvitation: (interactionId) =>
    api.patch(`/interactions/${interactionId}/final-status`, {
      status: "rejected",
    }),
  getProfileById: (candidateId) =>
    api.get(`/candidates/candidate/${candidateId}`),
  getAppearanceCount: (candidateId) =>
    api.get(`/insights/visibility-timeline/${candidateId}`),
  getAppearanceInSkills: (candidateId) =>
    api.get(`/insights/skill-breakdown/${candidateId}`),
  getVisibilityTimeline: (candidateId) =>
    api.get(`/insights/visibility-timeline/${candidateId}`),
};

export const jobVerificationApi = {
  verifyJob: (data) => api.post("/verification-requests", data),
  getVerificationStatus: (candidateId) =>
    api.get(`/verification-requests/candidate/${candidateId}`),
};

export const notificationApi = {
  create: (data) => api.post("/notifications", data),
  getByUser: (userId) => api.get(`/notifications/${userId}`),
  getUnreadByUser: (userId) => api.get(`/notifications/${userId}/unread`),
  markAsRead: (id) => api.patch(`/notifications/${id}/read`),
};

// employer endpoints
export const employerApi = {
  getAllEmployers: () => api.get("/employers"),
  addEmployerProfile: (userId, data) =>
    api.post(`/employers/${userId}/profile`, data),
  getEmployerProfile: (userId) => api.get(`/employers/${userId}/profile`),
  updateEmployerProfile: (userId, data) =>
    api.patch(`/employers/${userId}/profile`, data),
  updateEmployerContactInfo: (userId, data) =>
    api.patch(`/employers/${userId}/profile`, data),
  saveJob: (data) => api.post(`/jobs`, data),
  getAllCandidates: () => api.get(`/candidates`),
  getCandidateById: () => api.get(`/candidates/user/6865bb2908ba7790a41621b3`),

  getSearchedCandidates: (searchData) => {
    const params = new URLSearchParams();

    if (searchData.title) {
      params.append("title", searchData.title);
    }
    if (searchData.jobType) {
      params.append("jobType", searchData.jobType);
    }
    if (searchData.salaryFrom) {
      params.append("salaryFrom", searchData.salaryFrom);
    }
    // Keep salaryTo for filtering on candidate's 'min' salary.
    if (searchData.salaryTo) {
      params.append("salaryTo", searchData.salaryTo);
    }
    if (searchData.skills) {
      params.append("skills", searchData.skills);
    }

    // No change needed for `jobDescriptionKeywords` here, as per previous discussion.

    return api.get(`/candidates/search?${params.toString()}`);
  },

  getLastJobSearch: (jobId) => api.get(`/jobs/lastJob/${jobId}`),

  sendConnectionRequest: (data) => api.post(`/interactions`, data),
  fetchCurrentEmployees: (employerId) =>
    api.get(`/interactions?employerId=${employerId}&finalStatus=hired`),
  fetchAcceptedCandidates: (employerId) =>
    api.get(`/interactions/employer/${employerId}?consentStatus=accepted`),
  fetchPendingRequests: (employerId) =>
    api.get(`/interactions?employerId=${employerId}&status=active`),
  fetchEmployerTasks: (employerId) =>
    api.get(`/verification-requests/employer/${employerId}`),
  verifyTask: (taskId) =>
    api.patch(`/verification-requests/${taskId}`, { is_verified: true }),
  setCandidateToHired: (interactionId) =>
    api.patch(`/interactions/${interactionId}/final-status`, {
      status: "hired",
    }),
  saveTopCandidates: (jobId, data) => api.patch(`/jobs/${jobId}`, data),
  getLastJob: (employerId) => api.get(`/jobs/${employerId}`),
  saveCandidateAppearance: (data) =>
    api.post(`/insights/log-bulk-appearance`, data),
};

export { api };
